import { render, staticRenderFns } from "./StepIdentification.vue?vue&type=template&id=3da671aa&"
import script from "./StepIdentification.vue?vue&type=script&lang=js&"
export * from "./StepIdentification.vue?vue&type=script&lang=js&"
import style0 from "./StepIdentification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3da671aa')) {
      api.createRecord('3da671aa', component.options)
    } else {
      api.reload('3da671aa', component.options)
    }
    module.hot.accept("./StepIdentification.vue?vue&type=template&id=3da671aa&", function () {
      api.rerender('3da671aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/external/StepIdentification.vue"
export default component.exports